module.exports = __webpack_public_path__ + "img/280.ee26cf63.png";